// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Nqui","col":"styles_col__1n5Dr"};